$ = window.$ = window.jQuery = require('jquery');
import 'slick-carousel'
import reOrder from './components/reOrder';
import GotoScroll from './components/GotoScroll';
import modal from './components/modal';
import gForms from './components/gForms';


// Foundation magic below.
import Foundation from 'foundation-sites';
const $equalize = new Foundation.Equalizer( $('[data-equalizer-watch]'), {
    equalizeOnStack: true,
    equalizeByRow: true
});

const $accordion = new Foundation.Accordion( $('[data-accordion]'), {
    allowAllClosed: true
});

$(document).ready(function () {

    reOrder();
    gForms();

    if(!document.body.classList.contains('page-template-template-finder')) {

        $(document).on('click', 'a', function () {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                let target = $(this.hash);

                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                GotoScroll(target, 'click');
            }
        });

        if (window.location.href.indexOf("#") > -1) {
            var url = window.location.href;

            url = url.split('#');
            GotoScroll(url[1], 'load');
        }

        window.addEventListener('resize', function () {
            reOrder();
        });

    }
    const menu_icon = document.getElementById('menu-icon'),
        navigation = document.getElementById('navigation');

    menu_icon.onclick = function(e) {
        $(navigation).toggle();
        e.preventDefault();
    };

    modal();

    

    
	
});

$(".slides").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: true
});

jQuery(function($){

    $(document).on('click', '#edit-cookie-settings', function(e) {
        e.preventDefault();

        //console.log('qui');
		$("#cookie-disclaimer .cookie-selector").toggleClass("hidden");
		$("#edit-cookie-settings").toggleClass("hidden");
        $("#cookie-accept-button-footer").toggleClass("hidden");
    });

    var ACCEPT_COOKIE_NAME = 'viewed_cookie_policy';
	var ACCEPT_COOKIE_EXPIRE = 365;

	var ACCEPT_ANALYTICAL_COOKIE_NAME = 'accepts_analytics';
	var ACCEPT_VIDEO_COOKIE_NAME = 'accepts_video';
	var $cookiemessage = $('#cookie-disclaimer');
    var $cookielabel = $('.open-disclaimer');

    if (jQuery.cookie(ACCEPT_COOKIE_NAME) === null) {
        $cookiemessage.show();
    } else {
        $cookiemessage.hide();
    }

	$('#cookie-accept-button-all, #cookie-accept-button-footer').on('click',function(){
        var $this = $(this);
        var cookie = $this.data('cookie');
        if ($('#cookie-disclaimer .cookie-selector').hasClass('hidden') && cookie === 'all' ) {
            jQuery.cookie(ACCEPT_COOKIE_NAME, 'yes', {
                expires: ACCEPT_COOKIE_EXPIRE,
                path: '/'
            });
            jQuery.cookie(ACCEPT_ANALYTICAL_COOKIE_NAME, 'yes', {
                expires: ACCEPT_COOKIE_EXPIRE,
                path: '/'
            });
            jQuery.cookie(ACCEPT_VIDEO_COOKIE_NAME, 'yes', {
                expires: ACCEPT_COOKIE_EXPIRE,
                path: '/'
            });
           
            
        } else {
			if($('#functional-cookies').is(':checked')) {
				jQuery.cookie(ACCEPT_COOKIE_NAME, 'yes', { expires: ACCEPT_COOKIE_EXPIRE, path: '/' });
			}
			if($('#analytical-cookies').is(':checked')) {
				jQuery.cookie(ACCEPT_ANALYTICAL_COOKIE_NAME, 'yes', { expires: ACCEPT_COOKIE_EXPIRE, path: '/' });
			}
			if($('#video-cookies').is(':checked')) {
				jQuery.cookie(ACCEPT_VIDEO_COOKIE_NAME, 'yes', { expires: ACCEPT_COOKIE_EXPIRE, path: '/' });
			}
			
        }
	    $cookiemessage.addClass('hideCookiebar');
	    window.location = window.location;
	});

    $('#cookie-accept-page').on('click', function () {
        var $this = $(this);
        

            if ($('#functional-cookies-page').is(':checked')) {
                jQuery.cookie(ACCEPT_COOKIE_NAME, 'yes', {
                    expires: ACCEPT_COOKIE_EXPIRE,
                    path: '/'
                });
            }else {
                jQuery.cookie(ACCEPT_COOKIE_NAME, 'no', {
                    expires: ACCEPT_COOKIE_EXPIRE,
                    path: '/'
                });
            }
            if ($('#analytical-cookies-page').is(':checked')) {
                jQuery.cookie(ACCEPT_ANALYTICAL_COOKIE_NAME, 'yes', {
                    expires: ACCEPT_COOKIE_EXPIRE,
                    path: '/'
                });
            }else {
                jQuery.cookie(ACCEPT_ANALYTICAL_COOKIE_NAME, 'no', {
                    expires: ACCEPT_COOKIE_EXPIRE,
                    path: '/'
                });
            }
            if ($('#video-cookies-page').is(':checked')) {
				jQuery.cookie(ACCEPT_VIDEO_COOKIE_NAME, 'yes', {
					expires: ACCEPT_COOKIE_EXPIRE,
					path: '/'
				});
			}else {
				jQuery.cookie(ACCEPT_VIDEO_COOKIE_NAME, 'no', {
					expires: ACCEPT_COOKIE_EXPIRE,
					path: '/'
				});
			}
            


        $cookiemessage.addClass('hideCookiebar');
        window.location = window.location;
    });

    $('#cookie-reject-button-footer').on('click', function (e) {
        e.preventDefault();

        jQuery.cookie(ACCEPT_COOKIE_NAME, 'no', {
            expires: ACCEPT_COOKIE_EXPIRE,
            path: '/'
        });

        jQuery.cookie(ACCEPT_ANALYTICAL_COOKIE_NAME, 'no', {
            expires: ACCEPT_COOKIE_EXPIRE,
            path: '/'
        });

       

        

        
        $cookiemessage.addClass('hideCookiebar');
        //$cookiemessage.addClass('hideCookiebar');
			$cookielabel.removeClass('hidden');
        //$cookielabel.removeClass('hidden');

    });
    $('.open-disclaimer').on('click', function (e) {
        e.preventDefault();
        $cookiemessage.removeClass('hideCookiebar');
        $cookielabel.addClass('hidden');
    });
});


(function(jQuery) {
    jQuery.cookie = function(key, value, options) {
      // key and at least value given, set cookie...
      if (arguments.length > 1 && (!/Object/.test(Object.prototype.toString.call(value)) || value === null || value === undefined)) {
        options = jQuery.extend({}, options);
  
        if (value === null || value === undefined) {
          options.expires = -1;
        }
  
        if (typeof options.expires === 'number') {
          var days = options.expires, t = options.expires = new Date();
          t.setDate(t.getDate() + days);
        }
  
        value = String(value);
  
        return (document.cookie = [
          encodeURIComponent(key), '=', options.raw ? value : encodeURIComponent(value),
          options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
          options.path    ? '; path=' + options.path : '',
          options.domain  ? '; domain=' + options.domain : '',
          options.secure  ? '; secure' : ''
        ].join(''));
      }
  
        // key and possibly options given, get cookie...
        options = value || {};
        var decode = options.raw ? function(s) { return s; } : decodeURIComponent;
  
        var pairs = document.cookie.split('; ');
        for (var i = 0, pair; pair == pairs[i] && pairs[i].split('='); i++) {
            if (decode(pair[0]) === key) return decode(pair[1] || ''); // IE saves cookies with empty string as "c; ", e.g. without "=" as opposed to EOMB, thus pair[1] may be undefined
        }
        return null;
    };
  })(jQuery);

